
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 9a2.552 2.552 0 112.548-2.548A2.555 2.555 0 017.5 9zm0-3.963a1.411 1.411 0 101.411 1.415A1.413 1.413 0 007.5 5.041z","fill":"#8d98aa","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M7.498.7a6.149 6.149 0 013.569 1.119 5.592 5.592 0 012.193 3.373c.77 3.411-1.279 6.255-3.133 8.041a3.784 3.784 0 01-5.262 0C3.014 11.444.974 8.6 1.739 5.186a5.593 5.593 0 012.194-3.369A6.146 6.146 0 017.498.7zm0 12.476a2.652 2.652 0 001.853-.751C11 10.839 12.825 8.341 12.174 5.44a4.617 4.617 0 00-4.676-3.619 4.616 4.616 0 00-4.669 3.613c-.655 2.9 1.168 5.4 2.812 6.991a2.668 2.668 0 001.858.751z","fill":"#8d98aa"}})])
          )
        }
      }
    